import { Button, Flex } from 'components'

type FooterProps = {
  onSubmit: VoidFunction
  onCancel: VoidFunction
  isSubmitting?: boolean
  isSubmitDisabled?: boolean
}

export const Footer = ({ onCancel, onSubmit, isSubmitting, isSubmitDisabled }: FooterProps) => (
  <Flex width={'100%'} justifyContent={'space-between'} padding={'24px 8px'}>
    <Button variant="ghost" onClick={onCancel}>
      cancel_btn
    </Button>
    <Button isSubmitting={isSubmitting} onClick={onSubmit} disabled={isSubmitDisabled} variant={'fill'}>
      merge_btn
    </Button>
  </Flex>
)
